import React from 'react';
type Props = {
    desc?: any;
    pageTitle: string;
    bg: string;
    white?: boolean;
};

const HireProcessFinTechSoftware: React.FC<Props> = ({ pageTitle, desc, bg, white }) => {
    return (
        <section className={`section-py ${bg}`}>
            <div className={white ? 'text-white container lg:container mx-auto' : 'container lg:container mx-auto'}>
                <div className="row grid md:grid-cols-12 !gap-y-0">
                    <div className="md:col-span-8 md:col-start-3 mb-5 md:mb-[70px] lg:mb-0">
                        <div className="flex flex-col gap-2.5 text-center">
                            <h2 className="mb-0">{pageTitle}</h2>
                            <p className={white ? 'text-white mb-0 fw-600' : 'mb-0 fw-600'}>{desc}</p>
                        </div>
                    </div>
                    <div className="md:col-span-12 lg:col-span-12 xl:col-span-12 text-center about-us-animation agriculture-animation">
                        <div className="process-list process-list-about process-list-aiml process-list-fintech">
                            <div className={white ? 'process-item process-item-white text-center' : 'process-item text-center'}>
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-scope-analysis"></use>
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                            : 'text-textcolor fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                    }
                                >
                                    Scope Analysis Process
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-[#D7DEE5] fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    We begin by deeply understanding your business goals, compliance requirements, and user
                                    expectations. Through stakeholder workshops and market research, we define the scope, key
                                    features, tech stack, and third-party integrations to lay a solid foundation for success.
                                </p>
                            </div>
                            <div
                                className={
                                    white
                                        ? 'circle circle-white circle-reverse fitech-circle'
                                        : 'circle circle-reverse fitech-circle'
                                }
                            />
                            <div
                                className={
                                    white
                                        ? 'process-item  process-item-white process-item-reverse text-center'
                                        : 'process-item process-item-reverse text-center'
                                }
                            >
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white process-icon-reverse mx-auto mb-4 grid rounded-full'
                                            : 'process-icon process-icon-reverse mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-sprint-planning"></use>
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                            : 'text-textcolor fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                    }
                                >
                                    Sprint Planning & Execution
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-[#D7DEE5] fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    Our team follows agile sprints to break down the project into manageable phases — delivering
                                    usable features every few weeks. This ensures speed, flexibility, and full transparency
                                    throughout the fintech software development lifecycle.
                                </p>
                            </div>
                            <div className={white ? 'circle circle-white circle-2' : 'circle circle-2'} />
                            <div className={white ? 'process-item process-item-white text-center' : 'process-item text-center'}>
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-uat"></use>
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                            : 'text-textcolor fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                    }
                                >
                                    UAT & Release
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-[#D7DEE5] fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    Before launch, we conduct rigorous testing including unit tests, system tests, and user
                                    acceptance testing (UAT) to ensure your app meets both business and regulatory standards. Once
                                    validated, we prepare for a smooth and secure release across platforms.
                                </p>
                            </div>
                            <div
                                className={
                                    white ? 'circle circle-white circle-reverse circle-3' : 'circle circle-reverse circle-3'
                                }
                            />
                            <div
                                className={
                                    white
                                        ? 'process-item process-item-white process-item-reverse text-center'
                                        : 'process-item process-item-reverse text-center'
                                }
                            >
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-aftercare"></use>
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                            : 'text-textcolor fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                    }
                                >
                                    Aftercare & Optimization
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-[#D7DEE5] fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    Our work doesn&apos;t stop at launch. We provide continuous performance monitoring, security
                                    updates, and feature enhancements — helping your fintech product evolve with market demands
                                    and user feedback.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HireProcessFinTechSoftware;
